<template>
  <Card class="layout-card" style="height: 100%;">
    <div style="display:flex;justify-content: space-between;margin-bottom: 10px;flex-shrink: 0;">
      <div class="search-form">
        <div>
          <playSearch v-model="searchForm.playId" placeholder="请输入短剧名称进行搜索" style="width:200px"></playSearch>
        </div>
        <Input :maxlength="100" v-model="searchForm.seriesName" placeholder="请输入剧集名称" style="width: 200px;" />
        <Button type="primary" v-if="buttonMenu['/episode/view']" @click="getData()">查询</Button>
        <Button @click="handleReset()">重置</Button>
      </div>
      <div class="search-form">
        <Button type="primary" :disabled="selectedIds.length === 0"
          @click="handleBatchDel()">批量删除 <span v-if="selectedIds.length > 0">({{ selectedIds.length }})</span></Button>
        <Button type="primary" @click="handleOpenImport()">导入剧集</Button>
        <Button type="primary" v-if="buttonMenu['/episode/download']" :loading="downloading"
          @click="handleDownload()">下载模板</Button>
        <UploadFile showSlot v-if="buttonMenu['/episode/upload']" @handleSuccess="handleImport" accept=".xls,.xlsx"
          :uploadFunc="seriesResolve">
          <Button type="primary">导入模板</Button>
        </UploadFile>
      </div>
    </div>
    <div>
      <Table ref="epTable" :data="tableData" :columns="columns" :max-height="700"
        @on-selection-change="handleSelectionChange">
        <template #fileId="{ row }">
          <div>
            <img v-if="row.posterFileUrl" :src="row.posterFileUrl" style="width:100%;cursor:pointer" @click="$viewerApi({images:[row.posterFileUrl]})" />
          </div>
        </template>
        <template #fileUrl="{ row }">
          <div style="display:flex;">
            <Tooltip transfer class="tool" style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden"
              :max-width="200">
              <template #content>
                <div style="white-space: normal;">{{ row.fileUrl }}</div>
              </template>
              <span style="white-space:nowrap;text-overflow: ellipsis;overflow:hidden">{{ row.fileUrl }}</span>
            </Tooltip>
            <a style="cursor:pointer;flex-shrink: 0;margin-right: 10px;" @click="copyText(row.fileUrl)">复制</a>
          </div>
        </template>
        <template #action="{ row }">
          <div>
            <a style="margin-left: 10px;" v-if="buttonMenu['/episode/edit']" @click="handleOpenEditModal(row)">编辑</a>
            <Poptip confirm title="确定要删除吗？" v-if="buttonMenu['/episode/delete']" transfer @on-ok="handleDel(row)"><a
                style="margin-left: 10px;color: red">删除</a></Poptip>

          </div>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>
    <Modal v-model="editVisible" :title="(form.id ? '编辑' : '新增') + '剧集'">
      <Form @submit.native.prevent v-if="editVisible" :label-width="130" :model="form" ref="formRef">
        <FormItem label="所属短剧：" prop="playId" :rules="[{ required: true, message: '请选择所属短剧' }]">
          <playSearch v-model="form.playId" :name="form.playName"></playSearch>
        </FormItem>
        <FormItem label="集号：" prop="seriesNum" :rules="[{ required: true, message: '请输入集号' }]">
          <InputNumber :min="0" v-model="form.seriesNum" :max="99999" />
        </FormItem>
        <FormItem label="剧集名称：" prop="seriesName" :rules="[{ required: true, message: '请输入剧集名称' }]">
          <Input :maxlength="100" v-model="form.seriesName" />
        </FormItem>
        <FormItem prop="fileUrl" label="封面图片：" :rules="[{ required: true, message: '请上传封面' }]">
          <div>
            <UploadFileImg :uploadList="form.posterFileUrl ? [form.posterFileUrl] : []"
              @hanldDel="form.posterFileId = ''; form.posterFileUrl = ''"
              @handleSuccess="form = { ...form, posterFileId: $event.fileId, posterFileUrl: $event.fileUrl }">

            </UploadFileImg>
            <!-- <div v-if="form.fileUrl">
                          <img :src="form.fileUrl" style="cursor:pointer;" @click="$viewerApi({images:[form.fileUrl]})" />

                          <Icon type="md-trash" />
                        </div> -->
          </div>
          <!-- <Upload action="/api/file/upload" >上传</Upload> -->
        </FormItem>
        <FormItem label="视频文件：" prop="fileId">
          <!-- <Upload /> -->
          <div>
            <!-- <UploadFile accept=".mp4" disabled @handleSuccess="form={...form,fileId:$event.fileId,fileUrl:$event.fileUrl}" >

                      </UploadFile> -->
            <div v-if="form.fileId">
              {{ form.fileOriginalName }}
            </div>
            <div v-else>暂无视频</div>
          </div>
        </FormItem>
        <FormItem label="视频时长(秒)：" prop="seriesTimeFmt">
          <InputNumber :min="0" v-model="form.seriesTimeFmt" disabled style="color:#666;" :max="99999" />
        </FormItem>
        <FormItem label="价格(金币)：" prop="seriesPrice" :rules="[{ required: true, message: '请输入价格' }]">
          <InputNumber :min="0" v-model="form.seriesPrice" :max="99999" />
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit()">提交</Button>
      </template>
    </Modal>
    <Modal v-model="visible" title="导入剧集" :mask-closable="false">
      <Form @submit.native.prevent v-if="visible" :label-width="130" :model="importForm" ref="importFormRef">
        <FormItem label="所属短剧" prop="playId" :rules="[{ required: true, message: '请选择所属短剧' }]">
          <playSearch v-model="importForm.playId" :disabled="submitLoading"></playSearch>
        </FormItem>
        <FormItem label="剧集金额" prop="seriesPrice" :rules="[{ required: true, message: '请输入金额' }]">
          <InputNumber v-model="importForm.seriesPrice" :min="0" :disabled="submitLoading" />
        </FormItem>
        <!-- <FormItem label="选择文件：" prop="file" :rules="[{ required: true, message: '请选择zip文件' }]">
          <Upload :before-upload="handleUpload" action="/" :disabled="submitLoading">
            <Button icon="ios-cloud-upload-outline">选择文件</Button>
          </Upload>
          <div v-if="importForm.file"
            style="display: flex;justify-content: space-between;color:#aaa;align-items: center;width: 50%">
            <div>
              {{ importForm.file.name }}
            </div>
            <Icon type="md-close" :style="{cursor: !submitLoading?'pointer':''}" @click="!submitLoading&&(importForm.file=null)" />
          </div>
        </FormItem>
        <FormItem v-if="submitLoading">
          <Progress :percent="Math.floor(uploadProgress)" :stroke-width="30" status="active" text-inside />
        </FormItem> -->
        <FormItem label="百度云账号" prop="appId" :rules="[{ required: true, message: '请选择百度云账号' }]">
          <Select v-model="importForm.appId" @on-change="importForm.path='';handleGetPath()">
            <Option v-for="(item, index) in accountList" :key="index" :value="item.appId">{{ item.accountName }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="选择目录" prop="path" :rules="[{ required: true, message: '请选择目录' }]">
          <Row :gutter="12">
            <Col style="padding-left: 0;" :span="16">
              <Cascader :render-format="format" :disabled="!importForm.appId" :data="pathData" :load-data="handleGetPath"></Cascader>
            </Col>
            <Col style="padding-right: 0;" :span="7"><Button :disabled="!importForm.appId" type="info" @click="handleGetPath()">重新获取目录</Button></Col>
          </Row>
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="visible = false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmitImport()">提交</Button>
      </template>
    </Modal>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import playSearch from '@/components/playSearch'
import { getSeriesList, addSeries, delSeries, editSeries, getSeriesInfo, getSeriesTemplate, batchDelSeries } from '@/api/series'
import { uploadSeriesChunk as uploadSeries, mergeChunk, checkChunk, getBaiduPath, getBaiduAccounts, downloadVideo } from '@/api/play'
import { seriesResolve } from '@/api/common'
import SparkMD5 from 'spark-md5'
import { copyText } from '@/libs/util'
import UploadFile from '@/components/Upload'
import UploadFileImg from '@/components/Upload/uploadImg.vue'

export default {
  components: {
    Pages,
    UploadFile,
    UploadFileImg,
    playSearch
  },
  data() {
    return {
      pathLoading: false,
      editVisible: false,
      copyText,
      pathData: [],
      seriesResolve,
      importForm: {
        seriesPrice: null
      },
      form: {
        seriesNum: 1,
        seriesTime: 0,
        seriesMinPrice: 0
      },
      searchForm: {},
      downloading: false,
      submitLoading: false,
      importLoading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      uploadProgress: 0,
      visible: false,
      accountList: [],
      selectedIds: [],
      selectedRowsMap: {},
      isRestoring: false,
      columns: [
        {
          type: 'selection',
          width: 60
        },
        {
          title: 'id',
          width: 100,
          key: 'id'
        },
        {
          title: '所属短剧',
          key: 'playName',
          maxWidth: 500
        }, {
          title: '短剧中文名',
          key: 'chinesePlayName',
          tooltip: true,
          tooltipMaxWidth: 300,
          maxWidth: 100
        },
        {
          title: '封面',
          slot: 'fileId',
          width: 70
        },
        {
          title: '集号',
          width: 70,
          align: 'center',
          key: 'seriesNum'
        },
        {
          title: '剧集名称',
          width: 200,
          key: 'seriesName'
        },
        {
          title: '视频地址',
          key: 'fileUrl',
          slot: 'fileUrl',
          width: 300,
          tooltip: true
        },
        {
          title: '时长(秒)',
          width: 80,
          key: 'seriesTimeFmt'
        },
        {
          title: '价格(金币)',
          align: 'center',
          width: 120,
          key: 'seriesPrice'
        },
        {
          title: '播放量',
          align: 'center',
          width: 120,
          key: 'seriesPlayNum'
        },
        {
          title: '操作',
          width: 120,
          align: 'center',
          fixed: 'right',
          slot: 'action'
        }
      ]
    }
  },
  computed: {
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('main/episode')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods: {
    format(labels, selectedData) {
      const index = labels.length - 1;
      const data = selectedData[index] || false;
      if (data) {
        this.importForm.path = data.value
        return labels[index]
      }
      return labels[index];
    },
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      this.isRestoring = true
      getSeriesList({
        ...this.page,
        ...this.searchForm
      }).then(({ data }) => {
        this.tableData = data.records.map(row => ({
          ...row,
          _checked: !!this.selectedRowsMap[row.id]
        }))
        this.page.current = data.current
        this.page.total = data.total
        this.$nextTick(() => {
          this.isRestoring = false
        })
      })
    },
    handleSelectionChange(selection) {
      if (this.isRestoring) return
      // 更新选中状态映射表
      this.tableData.forEach(row => {
        const isSelected = selection.some(item => item.id === row.id)
        this.$set(this.selectedRowsMap, row.id, isSelected)
      })
      // 更新选中ID数组
      this.selectedIds = Object.keys(this.selectedRowsMap)
        .filter(id => this.selectedRowsMap[id])
        .map(Number)
    },
    handleGetPath(item, cb) {

      if (item) {
        item.loading = true
        getBaiduPath({
          path: item.value,
          appId: this.importForm.appId
        }).then(r => {
          item.loading = false
          item.children = [
            {
              label: item.label,
              value: item.value,
            },
            ...r.data.map(i => ({
              label: i.path,
              value: i.path,
              children: [],
              loading: false
            }))
          ]
          cb()
        })
      }
      else {
        this.pathData = []
        getBaiduPath({
        path: '/',
        appId: this.importForm.appId
      }).then(r => {
        this.pathData = r.data.map(i => ({
          label: i.path,
          value: i.path,
          children: [],
          loading: false
        }))
      }).catch(e=>{
        this.$Message.error('获取超时')
      })
      }
    },
    handleGetBaiduAccount() {
      getBaiduAccounts().then(r => {
        this.accountList = r.data
      })
    },
    async handleDownload() {
      try {
        this.downloading = true
        const { data } = await getSeriesTemplate({
          playId: this.searchForm.playId || ''
        })
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = data.fileUrl
        link.setAttribute('download', data.fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } finally {
        this.downloading = false
      }
    },
    handleOpenImport() {
      this.importForm = {
        seriesPrice: null
      }
      this.handleGetBaiduAccount()
      this.visible = true
    },
    handleImport() {
      this.$Message.success({
        duration: 3,
        content: '导入成功'
      })
      this.getData()
    },
    async handleOpenEditModal(row) {
      if (row) {
        const r = await getSeriesInfo(row.id)
        this.form = r.data
      } else {
        this.form = {
          seriesNum: 1,
          seriesTime: 0,
          seriesMinPrice: 0
        }
      }
      this.editVisible = true
    },
    handleUpload(e) {
      this.$set(this.importForm, 'file', e)

      return false
    },
    handleSubmitImport() {
      this.$refs.importFormRef.validate(async (r) => {
        if (r) {
          this.submitLoading = true
          try {
            await downloadVideo(this.importForm)
            this.$Message.success('任务已提交，请等待')
            this.visible = false
            this.submitLoading = false
          } catch {

            this.submitLoading = false
          } finally {
            // this.uploadProgress = 0
            this.getData()
          }
        }
      })

    },
    handleSubmit() {
      this.$refs.formRef.validate((r) => {
        if (r) {
          const func = this.form.id ? editSeries : addSeries
          this.submitLoading = true
          func({
            ...this.form
          }).then(r => {
            this.$Message.success('操作成功')
            this.getData(this.form.id ? this.page.current : 1)
            this.submitLoading = false
            this.editVisible = false
          }).catch(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleDel(row) {
      delSeries(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleBatchDel() {
      if (this.selectedIds.length === 0) return
      this.$Modal.confirm({
        title: '提示',
        content: `确定要删除选中的 ${this.selectedIds.length} 条数据吗？`,
        onOk: () => {
          batchDelSeries({ ids: [...this.selectedIds] }).then(() => {
            this.$Message.success('批量删除成功')
            this.selectedIds = []
            this.selectedRowsMap = {}
            this.getData()
          })
        }
      })
    },
    handleReset() {
      this.searchForm = {}
      this.$set(this.searchForm, 'playId', '')
    },
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;
  flex-wrap: wrap;

  &>* {
    margin: 0 5px;
    margin-bottom: 10px;
  }
}

/deep/.ivu-input-number-input[disabled] {
  color: #666;
}

.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.tool {
  /deep/.ivu-tooltip-rel {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
}
</style>